﻿import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";

export class F18_2014 extends BaseForm {

    override updateForm() {
        
    }

}

//export class F18_2014_PARTICIPATION extends BaseWidget {
//    updateForm() {
//        this.URL_PARTICIPATION_use_change();
//    }

//    URL_PARTICIPATION_use_change() {
//        this.muVisible((this.ui.URL_PARTICIPATION_use as HTMLInputElement).checked, "URL_PARTICIPATION_block");
//    }
//}

export class F18_TOTAL_CURRENCY extends BaseWidget {
    override muBindData(src) {
        super.muBindData({ VALUE: src });
    }

    override muFetchData() {
        return super.muFetchData().VALUE;
    }
}


export class F18_EXCLUDING_CURRENCY extends BaseWidget {
    override muBindData(src) {
        super.muBindData({ VALUE: src });
    }

    override muFetchData() {
        return super.muFetchData().VALUE;
    }
}

